import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';

import { ConnectVideoComponent } from '../container/connect-video/connect-video.component';

export const CONNECT_OVERLAY_DEFAULT_CONFIG: OverlayConfig = {
  hasBackdrop: true,
  height: '100%',
  width: '100%',
};

@Injectable()
export class ConnectVideoService {
  public overlayRef: OverlayRef;

  constructor(private overlay: Overlay) {}

  public initializeCall() {
    this.overlayRef = this.overlay.create(CONNECT_OVERLAY_DEFAULT_CONFIG);
    const connectVideoCpmPortal = new ComponentPortal(ConnectVideoComponent);
    this.overlayRef.attach(connectVideoCpmPortal);
  }

  public finalizeCall() {
    if (this.overlayRef) {
      this.overlayRef.detach();
    }
  }

  public disableBackdrop() {
    this.overlayRef.backdropElement?.classList.add('d-none');
    this.overlayRef.overlayElement?.classList.add('pointer-events-none');
  }

  public enableBackdrop() {
    this.overlayRef.backdropElement?.classList.remove('d-none');
    this.overlayRef.overlayElement?.classList.remove('pointer-events-none');
  }
}
